'use client';

import useSWR from 'swr';
import { tagsApi } from '@/lib/api';
import type { TransactionTag } from '@/types';
import { LONG_LIVED_SWR_OPTIONS, useAuthedFetcher } from './swrConfig';

/**
 * The tag catalog (VER-378): global (Vértice) + the user's personal tags, name-sorted by
 * the API. Long-lived — the catalog only changes on explicit create/delete, which go
 * through revalidateTagCatalog.
 */
export function useTags(enabled = true) {
  const authedFetch = useAuthedFetcher();

  return useSWR<TransactionTag[]>(
    enabled ? ['tags'] : null,
    async () => authedFetch((token) => tagsApi.list(token)),
    LONG_LIVED_SWR_OPTIONS,
  );
}
